// import facebookLogo from '@assets/images/facebookLogo.png';
// import twitterLogo from '@assets/images/twitterLogo.png';
import linkedinLogo from '@assets/images/linkedinLogo.png';

export const FooterSocialMedia = [
  {
    image: linkedinLogo,
    href: 'https://www.linkedin.com/company/perksbar/',
  },
];

export default FooterSocialMedia;
